import {Dispatch, SetStateAction, useState} from "react";
import type { SuperAgentRequest } from "superagent";

export interface UseRequest {
  data: any;
  setData: Dispatch<SetStateAction<any>>;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  error: Error | undefined;
  setError: Dispatch<SetStateAction<Error | undefined>>;
  meta: SuperAgentRequest | undefined;
  setMeta: Dispatch<SetStateAction<SuperAgentRequest | undefined>>;
}

const useRequest: () => UseRequest = () => {
  const [data, setData] = useState<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | undefined>();
  const [meta, setMeta] = useState<SuperAgentRequest | undefined>();

  return {
    data,
    setData,
    isLoading,
    setIsLoading,
    error,
    setError,
    meta,
    setMeta,
  }
}

export { useRequest };
